<template>
    <button ref="button"
            class="btn btn--vue"
            :class="classes"
            :disabled="disabled || loading"
            :title="titleText"
            @click.prevent="click">
        <i v-if="loading"
           class="fa-solid fa-spinner fa-spin" />
        <slot v-else></slot>

        <span v-if="badge"
              class="btn__badge">{{ badge }}</span>
    </button>
</template>

<script>
import { container } from '@/container';

export default {
    name: 'SquareBtn',

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        badge: {
            type: [Number, String],
            default: null,
        },
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'default',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        flex: {
            type: Boolean,
            default: false, // TODO: Can these always be flex? That improves the alignment of the button content.
        },
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: null,
        },
        titleKey: {
            type: String,
            default: null,
        },
        // Dim this button like it is disabled, but still perform the action if the user clicks on it.
        visuallyDisabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: [
        'click',
    ],

    computed: {
        classes() {
            return [
                this.active ? 'active' : '',
                this.block ? 'btn-block' : '',
                this.color ? 'btn-' + this.color : '',
                this.flex ? 'btn--flex' : '',
                this.size ? 'btn-' + this.size : '',
                this.visuallyDisabled ? 'visually-disabled' : '',
            ].filter((c) => !!c);
        },

        titleText() {
            if (!this.titleKey) {
                return null;
            }

            return container.langService.getText(this.titleKey);
        },
    },

    methods: {
        click() {
            this.$emit('click');
            setTimeout(() => {
                if (this.$refs.button) {
                    this.$refs.button.blur();
                }
            }, 100);
        },
    },
};
</script>

<style lang="less">
@import "../../less/variables";

.btn__badge {
    background: @brand-danger;
    color: @white;
    border-radius: 50%;
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, .1);
}
</style>
